import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import useGetFieldLabel from 'hooks/useGetFieldLabel';
import useGetDatasetDefinition from 'hooks/useGetDatasetDefinition';
import DATASET_TREND_BUTTON from '../constants';

const useFieldOptions = ({
  dataset,
  setAcceptedAggFuncs,
  fieldAndAggFunc,
  setFieldAndAggFunc,
}: {
  dataset: string;
  setAcceptedAggFuncs: React.Dispatch<React.SetStateAction<AggFunc[]>>;
  fieldAndAggFunc: {
    field: string;
    aggFunc: AggFunc;
  };
  setFieldAndAggFunc: React.Dispatch<
    React.SetStateAction<{
      field: string;
      aggFunc: AggFunc;
    }>
  >;
}) => {
  const { getFieldLabel } = useGetFieldLabel();
  const [options, setOptions] = useState<DropdownOption[]>([]);
  const getDatasetDefinition = useGetDatasetDefinition();

  useEffect(() => {
    const datasetDef = getDatasetDefinition(dataset);
    if (!datasetDef) {
      setFieldAndAggFunc({
        field: DATASET_TREND_BUTTON.DEFAULT_FIELD,
        aggFunc: 'count',
      });
      setOptions([]);
      return;
    }

    setOptions(
      _.sortBy(
        datasetDef.fields
          .filter(
            (f) =>
              f.type !== 'date' &&
              f.type !== 'dateText' &&
              f.type !== 'geo_point',
          )
          .filter((f) => {
            if (f.type === 'text') {
              return f.aggFuncs.includes('count');
            } else {
              return f.aggFuncs.includes('sum');
            }
          })
          .map((f) => {
            const label = getFieldLabel({
              field: f.field,
              dataType: dataset,
              isVerbose: true,
            });
            const isSelected = fieldAndAggFunc.field === f.field;
            const onSelected = () => {
              setAcceptedAggFuncs(f.aggFuncs);
              setFieldAndAggFunc((c) => ({
                field: f.field,
                aggFunc: f.aggFuncs.includes(c.aggFunc)
                  ? c.aggFunc
                  : f.aggFuncs[0],
              }));
            };

            return {
              label,
              isSelected,
              onSelected,
            };
          }),
        'label',
      ),
    );
  }, [
    dataset,
    fieldAndAggFunc.field,
    getDatasetDefinition,
    getFieldLabel,
    setAcceptedAggFuncs,
    setFieldAndAggFunc,
  ]);

  return {
    fieldOptions: options,
  };
};

export default useFieldOptions;
